module.exports = __webpack_public_path__ + "img/antes_despues_246.ed4bb1c7.png";